<template>
	<div>
		<v-data-table
			v-model="selectedChain"
			:headers="headersChain"
			:items="get_SlotsTable_Rotations_Chain_Filtered"
			hide-default-footer
			:disable-pagination="true"
			:items-per-page="-1"
			show-expand
			:expanded.sync="expandedChain"
			single-expand
			class="slotWarningsTable">
				<!-- >>> OpeningHours:Column -->
				<template v-slot:item="{ item, expand, isExpanded }">
					<tr style="height:85px">
						<td style="width:40px">
							<v-checkbox
								v-model="selectedChain"
								multiple
								:value="item"
								style="margin:0px;padding:0px;"
								hide-details />
						</td>
						<td><span>{{ item.children.length }}</span></td>
						<td><span>{{ item.dateRange }}</span></td>
						<td><span>{{ $dayjsLocalToUTC(item.slotTime, 'vt') }}</span></td>
						<td>
							<div>{{ item.aircraftType.code }}</div>
							<a>{{ item.changedAircraft.code }}</a>
						</td>
						<td>
							<div
								style="display: grid;grid-template-rows: auto auto;"
								:style="{gridTemplateColumns: item.flightNo[1] ? 'auto auto auto' : 'auto' }">
								<div>
									{{ item.flightNo[0] }}</div>
								<div v-if="item.flightNo[1]">
									/
								</div>
								<div v-if="item.flightNo[1]">
									{{ item.flightNo[1] }}
								</div>
								<a>
									{{ item.changedFlightNo[0] }}
								</a>
								<div v-if="item.changedFlightNo[1]">
									/
								</div>
								<a>
									{{ item.changedFlightNo[1] }}
								</a>
							</div>
						</td>
						<td>
							<div class="font-weight-bold">
								{{ item.airportSlot.aptCode }}
							</div>
						</td>
						<td>
							<div style="display: grid;grid-template-rows: auto auto;grid-template-columns: auto auto">
								<div>{{ item.slot[0] }}</div>
								<div>{{ item.slot[1] }}</div>
								<a>{{ item.changedSlot[0] }}</a>
								<a>{{ item.changedSlot[1] }}</a>
							</div>
						</td>
						<td>
							<v-tooltip
								v-for="(warning, index) in item.warnings"
								:key="index"
								top>
								<template v-slot:activator="{ on, attrs }">
									<v-icon
										color="red"
										:style="{marginLeft: index !== 0 ? '14px' : ''}"
										v-bind="attrs"
										v-on="on">
										{{ warning.icon }}
									</v-icon>
								</template>
								<span>{{ warning.text }}</span>
							</v-tooltip>
						</td>
						<td>
							<v-chip>{{ item.status }}</v-chip>
						</td>
						<td>
							<span>
								<v-icon small class="mr-3" disabled :class="get_ClassForEditedRow(item)" @click="onClick_slotEdit(item)">	mdi-pencil</v-icon>
								<v-icon small class="mr-3" @click="onClick_openSlotRequestDialog($event, item)">	mdi-send</v-icon>
								<v-icon small @click="selectedChain = [item], askToDeleteSlots()">	mdi-delete</v-icon>
							</span>
						</td>
						<td>
							<v-icon
								v-if="item.children.length > 1"
								class="pointer"
								@click="expand(!isExpanded)">
								{{ isExpanded ? 'mdi-chevron-up' : 'mdi-chevron-down' }}
							</v-icon>
						</td>
					</tr>
				</template>
				<!-- >>> Expanded:Column -->
				<template v-slot:expanded-item="{ headers, item }">
					<td
						:colspan="headersRotation.length + 2"
						style="padding:0 0 44px 0 !important;background-color:#f4e1e1;">
						<div style="margin-left:22px;height:44px;border-left:1px solid black;position:sticky;top:0px;">
							<h2 style="margin-left: 22px;height:100%;display:flex;align-items:center;">
								Rotation / Leg
							</h2>
						</div>
						<div style="display:flex;">
							<div style="width:44px;" />
							<v-data-table
								v-model="selectedRotation"
								:headers="headersRotation"
								:items="item.children"
								hide-default-footer
								:disable-pagination="true"
								:items-per-page="-1"
								style="width:calc(100% - 44px);height:100%;">
									<!-- >>> OpeningHours:Column -->
									<template v-slot:item="{ item, expand, isExpanded }">
										<tr style="height:85px">
											<td style="position:relative;width:40px">
												<span style="position:absolute;left:-22px;top:0;width:22px;height:22px;border-bottom:1px solid black;" />
												<span style="position:absolute;left:-22px;top:-63px;width:22px;height:84px;border-left:1px solid black;" />
												<v-checkbox
													v-model="selectedRotation"
													multiple
													:value="item"
													style="margin:0px;padding:0px;"
													hide-details />
											</td>
											<td>
												<span>{{ $dayjsLocalToUTC(item.slotTime, 'DD.MM.YYYY') }}</span>
											</td>
											<td><span>{{ $dayjsLocalToUTC(item.slotTime, 'vt') }}</span></td>
											<td>
												<div>{{ item.aircraftType.code }}</div>
												<a>{{ item.changedAircraft.code }}</a>
											</td>
											<td>
												<div style="display: grid;grid-template-rows: auto auto;" :style="{gridTemplateColumns: item.flightNo[1] ? 'auto auto auto' : 'auto' }">
													<div>
														{{ item.flightNo[0] }}</div>
													<div v-if="item.flightNo[1]">
														/
													</div>
													<div v-if="item.flightNo[1]">
														{{ item.flightNo[1] }}
													</div>
													<a>
														{{ item.changedFlightNo[0] }}
													</a>
													<div v-if="item.changedFlightNo[1]">
														/
													</div>
													<a>
														{{ item.changedFlightNo[1] }}
													</a>
												</div>
											</td>
											<td>
												<div class="font-weight-bold">
													{{ item.airportSlot.aptCode }}
												</div>
											</td>
											<td>
												<div style="display: grid;grid-template-rows: auto auto;grid-template-columns: auto auto">
													<div>{{ item.slot[0] }}</div>
													<div>{{ item.slot[1] }}</div>
													<a>{{ item.changedSlot[0] }}</a>
													<a>{{ item.changedSlot[1] }}</a>
												</div>
											</td>
											<td>
												<v-tooltip
													v-for="(warning, index) in item.warnings"
													:key="index"
													top>
													<template v-slot:activator="{ on, attrs }">
														<v-icon
															color="red"
															:style="{marginLeft: index !== 0 ? '14px' : ''}"
															v-bind="attrs"
															v-on="on">
															{{ warning.icon }}
														</v-icon>
													</template>
													<span>{{ warning.text }}</span>
												</v-tooltip>
											</td>
											<td>
												<v-chip>{{ item.status }}</v-chip>
											</td>
											<td>
												<span>
													<v-icon small class="mr-3" disabled :class="get_ClassForEditedRow(item)" @click="onClick_slotEdit(item)">	mdi-pencil</v-icon>
													<v-icon small class="mr-3" @click="onClick_openSlotRequestDialog($event, item)">	mdi-send</v-icon>
													<v-icon small @click="selectedRotation = [item], askToDeleteSlots()">	mdi-delete</v-icon>
												</span>
											</td>
										</tr>
									</template>
							</v-data-table>
						</div>
					</td>
				</template>
				<!-- <<< Expanded:Column -->
		</v-data-table>
		<sdr-slotmanagement-bottom-sheet-update
			v-if="showBottomSheet"
			v-model="showBottomSheet"
			:selectedSlots="selectedSlots"
			:editorMode="editorMode"
			:editorFlightLegMode="editorFlightLegMode" />

		<!-- >>> Sdr-Component, Slot Request Dialog -->
		<sdr-slotmanagement-slot-request-dialog
			v-if="showSlotRequestDialog"
			v-model="showSlotRequestDialog"
			:flights="selectedSlots"
			:selectedLayer="selectedLayer"
			:modus="slotRequestModus"
			:get-class-for-edited-row="get_ClassForEditedRow"
			:smallScreen="smallScreen" />
		<!-- <<< Sdr-Component, Slot Request Dialog -->
		<!-- >>> Dialog: 'Confirm Delete'  -->
		<v-dialog v-model="showConfirmDeleteDialog" max-width="500px" persistent>
			<v-card class="pa-4">
				<v-card-title>Are you sure you want to delete this slot?</v-card-title>
					<v-card-actions class="mt-8">
						<v-spacer />
						<v-btn style="width:120px" depressed outlined color="#ab3b7a" @click="handleResponse_deleteDialog(false)">
						Cancel
						</v-btn>
						<v-btn style="width:120px" depressed color="primary" @click="handleResponse_deleteDialog(true)">
							OK
							</v-btn>
						<v-spacer />
				</v-card-actions>
			</v-card>
		</v-dialog>
		<!-- <<< Dialog: 'Confirm Delete'  -->
	</div>
</template>

<script>
	import { mapGetters, mapActions } from 'vuex';
	import BottomSheetUpdate from './BottomSheet/BottomSheetUpdate.vue';
import SlotRequestDialog from '../../shared/SlotRequestDialog.vue';
import { eventBus } from '../../../../../../main';


    export default {
        name: 'Blocktimes',


		/* >>> *************************************************************** / /* Components */
		components: {
			'sdr-slotmanagement-bottom-sheet-update': BottomSheetUpdate,
			'sdr-slotmanagement-slot-request-dialog': SlotRequestDialog
		}, // eo components{}
		/* <<< ****************************************************************/

        /* >>> *************************************************************** / /* Props */
		props: {
			smallScreen: Boolean
		}, // eo props{}
        /* <<< ****************************************************************/



		/* >>> *************************************************************** / /* Data */
		data: function() {

			return {
				// >>> ------------------------------------ Tables Headers
				headersChain: [
					{ text: '', value: 'data-table-select', class: 'sticky-header grey lighten-3' },
					{ text: 'Chain', value: '', class: 'sticky-header grey lighten-3' },
					{ text: 'Date', value: 'slotTime', class: 'sticky-header grey lighten-3' },
					{ text: 'DOW', value: 'slotTime', class: 'sticky-header grey lighten-3' },
					{ text: 'A/C', value: 'aircraftType', class: 'sticky-header grey lighten-3' },
					{ text: 'Flight No.', value: 'flightNo', class: 'sticky-header grey lighten-3' },
					{ text: 'Airport', value: 'airportSlot.aptCode', class: 'sticky-header grey lighten-3' },
					{ text: 'Slot', value: 'slot', class: 'sticky-header grey lighten-3' },
					{ text: 'Warnings', value: 'warnings', class: 'sticky-header grey lighten-3' },
					{ text: 'Status', value: 'status', class: 'sticky-header grey lighten-3' },
					{ text: 'Actions', value: 'actions', sortable: false, class: 'sticky-header grey lighten-3' },
					{ text: '', value: 'data-table-expand', class: 'sticky-header grey lighten-3' }
				],
				headersRotation: [
					{ text: '', value: 'data-table-select', class: 'sticky-header grey lighten-3' },
					{ text: 'Date', value: 'slotTime', class: 'sticky-header grey lighten-3' },
					{ text: 'DOW', value: 'slotTime', class: 'sticky-header grey lighten-3' },
					{ text: 'A/C', value: 'aircraftType', class: 'sticky-header grey lighten-3' },
					{ text: 'Flight No.', value: 'flightNo', class: 'sticky-header grey lighten-3' },
					{ text: 'Airport', value: 'airportSlot.aptCode', class: 'sticky-header grey lighten-3' },
					{ text: 'Slot', value: 'slot', class: 'sticky-header grey lighten-3' },
					{ text: 'Warnings', value: 'warnings', class: 'sticky-header grey lighten-3' },
					{ text: 'Status', value: 'status', class: 'sticky-header grey lighten-3' },
					{ text: 'Actions', value: 'actions', sortable: false, class: 'sticky-header grey lighten-3' }
				],
				// <<< ------------------------------------ Tables Headers
				// >>> ------------------------------------ Table Chains
				selectedChain: [],
				expandedChain: [],
				// <<< ------------------------------------ Table Chains
				// >>> ------------------------------------ Table Rotations
				selectedRotation: [],
				expandedRotation: [],
				// <<< ------------------------------------ Table Rotations
				// >>> ------------------------------------ Table Action Slot Edit
				showBottomSheet: false,
				editorMode: '',
				editorFlightLegMode: '',
				// <<< ------------------------------------ Table Action Slot Edit
				// >>> ------------------------------------ Table Action Slot Request
				selectedSlots: [],
				showSlotRequestDialog: false,
				selectedLayer: 0,
				// <<< ------------------------------------ Table Action Slot Request
				// >>> ------------------------------------ Table Action Slot Delete
				showConfirmDeleteDialog: false,
				deleteSlots: [],
				resolver_confirmDeleteSlot: null,
				rejecter_confirmDeleteSlot: null
				// <<< ------------------------------------ Table Action Slot Delete
			};

		}, // eo function data()
		/* <<< ****************************************************************/



        /* >>> *************************************************************** / /* Computed */
		computed: {

			...mapGetters([
				'get_SlotsTable_Rotations_Chain',
				'get_SlotsTable_Rotations_Chain_Filtered'
			])

		}, // eo function destroyed()
		/* <<< ****************************************************************/

		/* >>> *************************************************************** / /* watch */
        watch: {}, // eo computed{}
		/* <<< ****************************************************************/



        /* >>> *************************************************************** /  /* LifeCycles */
        /***********************************************************************
        * Lifecyclehook::created
        *
        * Desc:
        * Note:
        *
        */
	created: function () {

		const me = this;


		me.$toc('>>> views/slotmanagement/componentens/core/slots/SlotsTable.vue >>> onClick_slotEdit');
		eventBus.$on('createSlotRequest', me.onEmit_openSlotRequestDialog);
		eventBus.$on('createslotclicked', me.onEmit_createSlotclicked);
		eventBus.$on('deleteslotclicked', me.askToDeleteSlots);

		}, // eo function created()
		/* <<< ****************************************************************/

		/***********************************************************************
        * Lifecyclehook::destroyed
        *
        * Desc:
        * Note:
        *
        */
		destroyed: function() {}, // eo watch{}
        /* <<< ****************************************************************/



        /* >>> *************************************************************** / /* Methods */
		methods: {

			/*******************************************************************
			* mapActions()
			*
			* Desc:
			*
			*/
			...mapActions([
				'actn_call_slotmanagement_deleteSlots'
			]), // eof mapActions()

			/*******************************************************************
			* onClick_slotEdit()
			*
			* Desc:
            * Note:
            *
			*/
			onClick_slotEdit: function (slot) {

				const me = this;


				me.$toc('>>> views/slotmanagement/componentens/core/slots/SlotsTable.vue >>> onClick_slotEdit');
				me.showBottomSheet = true;
				me.selectedSlots = [slot];
				me.editorMode = 'create';
				me.editorFlightLegMode = 'rotation';
			}, // eo function helper_getSlotInfo()

			/*******************************************************************
			* onClick_openSlotRequestDialog()
			*
			* Desc:
            * Note:
            *
			*/
			onClick_openSlotRequestDialog: function (event, slot) {

				const me = this;


				me.$toc('>>> views/slotmanagement/componentens/core/slots/SlotsTable.vue >>> onClick_openSlotRequestDialog');
				event.stopPropagation();
				me.selectedChain = [];
				me.selectedRotation = [];
				if (slot.layer === 1) {
					me.selectedChain.push(slot);
				} else if (slot.layer === 2) {
					me.selectedRotation.push(slot);
				}
				me.selectedSlots = [slot];
				me.selectedLayer = slot.layer;
				me.slotRequestModus = 'slot';
				me.showSlotRequestDialog = true;

			}, // eo function onClick_openSlotRequestDialog()

			/*******************************************************************
			* onClick_openSlotRequestDialog()
			*
			* Desc:
            * Note:
            *
			*/
			onEmit_openSlotRequestDialog: function () {

				const me = this;


				me.$toc('>>> views/slotmanagement/componentens/core/slots/SlotsTable.vue >>> onEmit_openSlotRequestDialog');
				if (me.selectedChain.length > 0) {
					me.selectedLayer = 1;
					me.selectedSlots = me.selectedChain;
				} else if (me.selectedRotation.length > 0) {
					me.selectedLayer = 2;
					me.selectedSlots = me.selectedRotation;
				}
				me.slotRequestModus = 'slot';
				me.showSlotRequestDialog = true;

			}, // eo function onClick_openSlotRequestDialog()

			/*******************************************************************
			* onEmit_createSlotclicked()
			*
			* Desc:
            * Note:
            *
			*/
			onEmit_createSlotclicked: function () {

				const me = this;


				me.$toc('>>> views/slotmanagement/componentens/core/slots/SlotsTable.vue >>> onEmit_createSlotclicked');
				me.editorMode = 'create';
				me.editorFlightLegMode = 'single';
				me.showBottomSheet = true;

			}, // eo function onEmit_createSlotclicked()

			/*******************************************************************
            * get_ClassForEditedRow()
            *
            * Desc: Returns selected Class if Row was edited (prop: 'wasEdited')
            * Note:
            *
            */
			get_ClassForEditedRow: function(item) {

                const me = this;


				// me.$toc('>>> views/flights/slotmanagement/FlightsTable.vue >>> get_ClassForEditedRow');
				return item.wasEdited === true ? 'rowWasEdited' : '';

			}, // eo function get_ClassForEditedRow()

			/*******************************************************************
			* onClick_slotDelete()
			*
			* Desc:
            * Note:
            *
			*/
			onClick_slotDelete: function () {

				const me = this,
					payload = [];


				me.$toc('>>> views/slotmanagement/componentens/core/slots/SlotsTable.vue >>> onClick_slotDelete');
				if (me.deleteSlots.layer === 1) {
					me.deleteSlots.children.forEach(rotation => {
						rotation.children.forEach(slot => {
							slot.slotChangeLogs.forEach(slotChangeLog => {
								slotChangeLog.slotIds.forEach(id => {
									payload.push(id);
								});
							});
						});
					});
				} else if (me.deleteSlots.layer === 2) {
					me.deleteSlots.children.forEach(slot => {
						slot.slotChangeLogs.forEach(slotChangeLog => {
							slotChangeLog.slotIds.forEach(id => {
								payload.push(id);
							});
						});
					});
				}
				me.actn_call_slotmanagement_deleteSlots({ slots: payload });
			}, // eo function onClick_slotDelete()

			/*******************************************************************
			* onEmit_deleteSlotclicked()
			*
			* Desc:
            * Note:
            *
			*/
			onEmit_deleteSlotclicked: function () {

				const me = this,
					payload = [];


				me.$toc('>>> views/slotmanagement/componentens/core/slots/SlotsTable.vue >>> onEmit_deleteSlotclicked');
				if (me.selectedChain.length > 0) {
					me.selectedChain.forEach(chain => {
						chain.children.forEach(rotation => {
							rotation.children.forEach(slot => {
								slot.slotChangeLogs.forEach(slotChangeLog => {
									slotChangeLog.slotIds.forEach(id => {
										payload.push(id);
									});
								});
							});
						});
					});
				} else if (me.selectedRotation.length > 0) {
					me.selectedRotation.forEach(rotation => {
						rotation.children.forEach(slot => {
							slot.slotChangeLogs.forEach(slotChangeLog => {
								slotChangeLog.slotIds.forEach(id => {
									payload.push(id);
								});
							});
						});
					});
				}
				me.actn_call_slotmanagement_deleteSlots({ slots: payload });
			}, // eo function onEmit_deleteSlotclicked()

			/*******************************************************************
			* askToDeleteSlots()
			*
			* Desc:
            * Note:
            *
			*/
			askToDeleteSlots: function () {

				const me = this;


				me.$toc('>>> views/slotmanagement/componentens/core/slots/SlotsTable.vue >>> askToDeleteSlots');
				me.showConfirmDeleteDialog = true;
				me.promise_confirmDeletion()
					.then(() => {
						me.onEmit_deleteSlotclicked();
					})
					.catch(() => {});
			}, // eo function askToDeleteSlots()

			/*******************************************************************
			* promise_confirmDeletion()
			*
			* Desc:
            * Note:
            *
			*/
			promise_confirmDeletion: function () {

				const me = this;

				me.$toc('>>> views/slotmanagement/componentens/core/slots/SlotsTable.vue >>> promise_confirmDeletion');
				return new Promise((resolve, reject) => {
					me.resolver_confirmDeleteSlot = resolve;
					me.rejecter_confirmDeleteSlot = reject;
				});
			}, // eo function promise_confirmDeletion()

			/*******************************************************************
			* handleResponse_deleteDialog()
			*
			* Desc:
            * Note:
            *
			*/
			handleResponse_deleteDialog: function (response) {

				const me = this;


				me.$toc('>>> views/slotmanagement/componentens/core/slots/SlotsTable.vue >>> handleResponse_deleteDialog');
				me.showConfirmDeleteDialog = false;
				if (response) {
					me.resolver_confirmDeleteSlot();
				} else {
					me.rejecter_confirmDeleteSlot();
				}
				me.resolver_confirmDeleteSlot = null;
				me.rejecter_confirmDeleteSlot = null;
			} // eo function handleResponse_deleteDialog()

		} // eo methods{}
        /* <<< ****************************************************************/

    };
</script>


<style scoped>
	.v-data-table /deep/ .sticky-header {
		position: sticky;
		top: 0px;
		z-index: 1;
	}

	.v-data-table /deep/ .v-data-table__wrapper {
		margin-top: 0px;
		overflow: unset;
	}

	.slotWarningsTable >>> tbody tr:hover {
        background-color: #ab3b7b1b !important;
     }

	.rowWasEdited {
		border: 2px solid #AB3B7C;
		padding: 2px;
	}
</style>
